module.exports = __webpack_public_path__ + "static/media/appfemale.49ea66b1.png";